import dayjsBase from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import isoWeeksInYear from "dayjs/plugin/isoWeeksInYear";
import isTodayPlugin from "dayjs/plugin/isToday";
import relativeTime from "dayjs/plugin/relativeTime";
import timeZonePlugin from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utcPlugin from "dayjs/plugin/utc";
import weekdayPlugin from "dayjs/plugin/weekday";

dayjsBase.extend(isBetween);
dayjsBase.extend(customParseFormat);
dayjsBase.extend(weekdayPlugin);
dayjsBase.extend(utcPlugin);
dayjsBase.extend(isTodayPlugin);
dayjsBase.extend(updateLocale);
dayjsBase.extend(relativeTime);
dayjsBase.extend(timeZonePlugin);
dayjsBase.extend(isoWeek);
dayjsBase.extend(isoWeeksInYear);

export const dayjs = dayjsBase;
